import type { TenantConfig } from "./types";
import { defaultConfig } from "./default";

/**
 * Coca-Cola tenant configuration
 */
export const cocaColaConfig: TenantConfig = {
  ...defaultConfig,
  id: "coca-cola",
  name: "Coca-Cola",
  branding: {
    logo: "/Images/wint-coca-cola-logo-small.png",
    logoSmall: "/Images/coca-cola-logo-small.png",
    favicon: "/favicon.ico",
    primaryColor: "#E31937", // Coca-Cola red
    secondaryColor: "#000000", // Black
    companyName: "Coca-Cola",
  },
  terminology: {
    ...defaultConfig.terminology,
    line: "Skid", // Coca-Cola uses "Skid" instead of "Line"
    lines: "Skids",
  },
  features: {
    ...defaultConfig.features,
    weeklyTrend: false,
    valveStatus: false,
    shiftReport: false,
  },
  defaults: {
    ...defaultConfig.defaults,
    unitSystem: "imperial", // Coca-Cola uses imperial units
    timezone: "America/New_York",
    dateFormat: "MM/dd/yyyy",
    dateTimeFormat: "MM/dd/yyyy hh:mm a",
  },
  routes: {
    ...defaultConfig.routes,
    weeklyTrend: false,
    valveStatus: false,
    shiftReport: false,
  },
  // Imperial units for Coca-Cola
  unitLabels: {
    volume: "Gal",
    volumeLarge: "Gal",
    flowRate: "gal/min",
    temperature: "°F",
    duration: "min",
  },
  conversionFactors: {
    litersToVolume: 0.264172, // Liters to gallons
    litersToVolumeLarge: 0.264172, // Liters to gallons (same for Coca-Cola)
    flowRateConversion: 0.00440287, // L/h to gal/min
    temperatureConversion: (celsius: number) => (celsius * 9) / 5 + 32, // Celsius to Fahrenheit
  },
  calculatedColumns: {
    objectDetails: [
      {
        id: "loss",
        header: "Loss",
        formula: "volume - recycledVolume - drainedVolume",
        group: "Metrics",
        format: "volume",
        defaultVisible: false, // Hidden by default since not in store's initial state
        align: "center",
      },
    ],
  },
};
